import { Component, OnChanges, Output, Input, EventEmitter, SimpleChanges } from '@angular/core';
import { SortedTableClass, IAction, ActionType } from '@aston/foundation';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DateFormatPipe } from '@aston/foundation/pipes';
import { UserStatus } from '@aston/middle-users-admin';
import { NgClass } from '@angular/common';

import { IAccountInformationModel } from '../../../user-module/models';
import { FederationUsersListSortProp } from '../../enums';
import { IFederationUser } from '../../models';

@Component({
	selector: 'federation-users-list-table',
	templateUrl: './federation-users-list-table.component.html',
	imports: [TranslateDirective, NgClass, NgbTooltipModule, DateFormatPipe, TranslatePipe]
})
export class FederationUsersListTableComponent extends SortedTableClass<IFederationUser, FederationUsersListSortProp> implements OnChanges {
	@Output() status = new EventEmitter<IAction>();
	@Output() registrationRequest = new EventEmitter<IAction>();
	@Input() currentUser: IAccountInformationModel;

	sortCols = FederationUsersListSortProp;
	userStatus = UserStatus;

	currentFederationUser: IFederationUser;

	ngOnChanges(changes: SimpleChanges) {
		if (this.currentUser && changes.list) {
			this.currentFederationUser = this.list.items.find(u => u.userId === this.currentUser.id);
		}
	}

	changeUserStatus(userId: number, userStatus: UserStatus) {
		this.status.emit({type: ActionType.UPDATE, value: {userId, userStatus}});
	}

	resendRegistrationRequest(userId: number) {
		this.registrationRequest.emit({type: ActionType.UPDATE, value: {userId}});
	}
}
